export default __webpack_public_path__ + "static/media/dalalBullc_500.abaf07e4.png";